/* @generated from adl module ferovinum.datacontracts.marketdata */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';

export interface RateCurveRawRecord {
  id: common_strings.StringNE;
  code: common_strings.StringNE;
  interpolation: common_strings.StringNE;
  period: common_strings.StringNE;
  points: common_strings.StringNE;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeRateCurveRawRecord(
  input: {
    id: common_strings.StringNE,
    code: common_strings.StringNE,
    interpolation: common_strings.StringNE,
    period: common_strings.StringNE,
    points: common_strings.StringNE,
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): RateCurveRawRecord {
  return {
    id: input.id,
    code: input.code,
    interpolation: input.interpolation,
    period: input.period,
    points: input.points,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const RateCurveRawRecord_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.datacontracts.marketdata","decl":{"annotations":[{"value":{"datasetName":"raw_rate_curves"},"key":{"moduleName":"ferovinum.datacontracts.common","name":"RawExportDataset"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"code","default":{"kind":"nothing"},"name":"code","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"interpolation","default":{"kind":"nothing"},"name":"interpolation","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"period","default":{"kind":"nothing"},"name":"period","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"points","default":{"kind":"nothing"},"name":"points","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"RateCurveRawRecord","version":{"kind":"nothing"}}};

export const snRateCurveRawRecord: ADL.ScopedName = {moduleName:"ferovinum.datacontracts.marketdata", name:"RateCurveRawRecord"};

export function texprRateCurveRawRecord(): ADL.ATypeExpr<RateCurveRawRecord> {
  return {value : {typeRef : {kind: "reference", value : snRateCurveRawRecord}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.datacontracts.marketdata.RateCurveRawRecord" : RateCurveRawRecord_AST
};
